module.exports = __webpack_public_path__ + "static/etno-755701269213f8c9c1a60a09c8cfc9e2.jpeg";